import {
    AudioManager,
    globalAudioManager,
} from '@wonderlandengine/spatial-audio';

export enum Sounds {
    None = 0,
    Footsteps,
    DoorOpen,
    DoorClose,
    DoorScqueek,
    ShowerCurtain,

    Laugh,
    Jumpscare1,
    Jumpscare2,
    Jumpscare3,

    IntroMusic = 1000,
    MainMusic,
}

export class MusicManager {
    private static _instance: MusicManager;

    static MusicFiles: { path: string | string[]; id: Sounds }[] = [
        { path: 'DollysHouseIntro.mp3', id: Sounds.IntroMusic },
        { path: 'DollysHouse.mp3', id: Sounds.MainMusic },
    ];

    static get instance(): MusicManager {
        if (!MusicManager._instance) {
            MusicManager._instance = new MusicManager();
        }
        return MusicManager._instance;
    }

    private get _audioManager(): AudioManager {
        return globalAudioManager as AudioManager;
    }
    musicVolume = 0.2;

    private _loadedSongs: Sounds[] = [];
    private _isPaused: boolean = false;
    private _currentPlayingId: number = -1;

    private constructor() {}

    async init() {
        const loadPromises = MusicManager.MusicFiles.map((musicfile) => {
            return this._audioManager
                .load(musicfile.path, musicfile.id)
                .then(() => {
                    this._loadedSongs.push(musicfile.id);
                })
                .catch((error) => {
                    console.error(
                        `Failed to load music file ${musicfile.id}:`,
                        error
                    );
                    throw error;
                });
        });

        return Promise.all(loadPromises);
    }

    playMusic(id: Sounds) {
        if (this._currentPlayingId !== 0) {
            this.stopMusic();
        }

        if (this._loadedSongs.includes(id)) {
            this._currentPlayingId = this._audioManager.play(id, {
                volume: this.musicVolume,
                loop: true,
            });
        } else {
            console.warn(`Music with ID ${id} is not loaded.`);
        }
    }
    stopMusic() {
        if (this._currentPlayingId !== -1) {
            this._audioManager.stop(this._currentPlayingId);
            this._currentPlayingId = -1;
        }
    }
}

export class SoundManager {
    private static _instance: SoundManager;

    static SoundFiles: { path: string | string[]; id: Sounds }[] = [
        { path: 'sfx/instrument-jumpscare.wav', id: Sounds.Jumpscare1 },
        { path: 'sfx/showercurtain.mp3', id: Sounds.ShowerCurtain },
    ];

    static get instance(): SoundManager {
        if (!SoundManager._instance) {
            SoundManager._instance = new SoundManager();
        }
        return SoundManager._instance;
    }
    private get _audioManager(): AudioManager {
        return globalAudioManager as AudioManager;
    }
    private _loadedSounds: Sounds[] = [];
    private constructor() {}
    async init() {
        const loadPromises = SoundManager.SoundFiles.map((soundfile) => {
            return this._audioManager
                .load(soundfile.path, soundfile.id)
                .then(() => {
                    this._loadedSounds.push(soundfile.id);
                })
                .catch((error) => {
                    console.error(
                        `Failed to load sound file ${soundfile.id}:`,
                        error
                    );
                    throw error;
                });
        });

        return Promise.all(loadPromises);
    }
    play(id: Sounds) {
        this._audioManager.play(id);
    }
}
